export default "__VITE_ASSET__Bl$F2ahb__"